import React from 'react';

import { useIntl } from 'react-intl-next';

import EmptyState, { type EmptyStateProps } from '@atlaskit/empty-state';

import { messages } from '../../../../messages';

import errorImage from './assets/loading-error.svg';
import { CenteredWrapper } from './styled';

interface OwnProps {
	errorContent:
		| Pick<EmptyStateProps, 'header' | 'description' | 'primaryAction' | 'imageUrl'>
		| undefined;
	testId: string;
}

export const ErrorState = ({ errorContent, testId }: OwnProps) => {
	const { formatMessage } = useIntl();

	const defaultEmptyStateProps: EmptyStateProps = {
		testId: `${testId}-error`,
		header: formatMessage(messages.errorHeader),
		imageUrl: errorImage,
	};

	return (
		<CenteredWrapper>
			{errorContent ? (
				<EmptyState testId={defaultEmptyStateProps.testId} {...errorContent} />
			) : (
				<EmptyState {...defaultEmptyStateProps} />
			)}
		</CenteredWrapper>
	);
};
